module.exports = __webpack_public_path__ + "img/ditu.540e50d8.png";